import { render, staticRenderFns } from "./AdvertSlotContent.vue?vue&type=template&id=3c381860&scoped=true"
import script from "./AdvertSlotContent.vue?vue&type=script&lang=js"
export * from "./AdvertSlotContent.vue?vue&type=script&lang=js"
import style0 from "./AdvertSlotContent.vue?vue&type=style&index=0&id=3c381860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c381860",
  null
  
)

export default component.exports